import { motion } from "framer-motion";
import { PILLAR_META } from "./meta";
import InfoTip from "@/components/InfoTip";

export default function Pillars({ pillars = {}, beginner = false }) {
  const keys = Object.keys(PILLAR_META).filter((k) => k in pillars);
  return (
    <div className="clay p-8" data-testid="pillars-card">
      <span className="label-eyebrow">{beginner ? "Your health, in 9 building blocks" : "Performance pillars"}</span>
      {beginner && (
        <p className="text-sm text-muted2 mt-2" data-testid="pillars-beginner-hint">
          Each bar is one part of your health, scored 0–100. Tap the <span className="font-medium">?</span> next to any name to learn what it means.
        </p>
      )}
      <div className="grid sm:grid-cols-2 gap-x-8 gap-y-5 mt-5">
        {keys.map((k, i) => {
          const meta = PILLAR_META[k];
          const val = pillars[k];
          const Icon = meta.icon;
          return (
            <div key={k} data-testid={`pillar-${k}`}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <Icon size={16} weight="fill" color={meta.color} />
                  <span className="text-sm font-medium">{meta.label}</span>
                  <InfoTip termId={k === "mental" ? "mental" : k} />
                </div>
                <span className="text-sm font-semibold tabular-nums" style={{ color: meta.color }}>{val}</span>
              </div>
              <div className="h-2 rounded-full bg-secondary overflow-hidden">
                <motion.div
                  className="h-full rounded-full"
                  style={{ background: meta.color }}
                  initial={{ width: 0 }}
                  animate={{ width: `${val}%` }}
                  transition={{ duration: 0.9, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
                />
              </div>
              {beginner && <p className="text-xs text-muted2 mt-1.5">{meta.desc}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
